module.exports = "data:image/png;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiZDk4ODA2ODcyNWUzOGMxZjNiYTdmN2Q0YTBiMzAzZjgucG5nIjs="